import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaInstagram,
  FaFacebookF,
  FaTwitter,
  FaCcVisa,
  FaCcMastercard,
  FaPaypal,
  FaWhatsapp,
} from 'react-icons/fa';

const Footer = () => (
  <footer className="bg-gray-900 text-white pt-10 pb-6">
    <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10">
      {/* Logo and description */}
      <div className="text-center md:text-left">
        <img src="/assets/logo.png" alt="Logo" className="h-10 mb-4 mx-auto md:mx-0" />
        <p className="text-sm text-gray-400 max-w-xs mx-auto md:mx-0">
          Timeless, elegant jewelry crafted just for you.
        </p>
      </div>

      {/* Company Links */}
      <div className="text-center md:text-left">
        <h3 className="uppercase font-semibold text-gray-200 mb-4">Company</h3>
        <ul className="text-sm space-y-2 text-gray-400">
          <li><Link to="/about">About Us</Link></li>
          <li><Link to="/contact">Contact</Link></li>
          <li><Link to="/faq">FAQ</Link></li>
          <li><Link to="/policies">Policies</Link></li>
        </ul>
      </div>

      {/* Categories */}
      <div className="text-center md:text-left">
        <h3 className="uppercase font-semibold text-gray-200 mb-4">Categories</h3>
        <ul className="text-sm space-y-2 text-gray-400">
  <li><Link to="/shop?category=necklace">Necklaces</Link></li>
  <li><Link to="/shop?category=bracelet">Bracelets</Link></li>
  <li><Link to="/shop?category=ring">Rings</Link></li>
  <li><Link to="/shop?category=earring">Earrings</Link></li>
  <li><Link to="/shop">Collections</Link></li> {/* Optional: general shop view */}
</ul>
      </div>

      {/* Contact & Social */}
      <div className="text-center md:text-left">
        <h3 className="uppercase font-semibold text-gray-200 mb-4">Contact Us</h3>
        <div className="flex justify-center md:justify-start gap-6 text-2xl text-gray-400">
          <a
            href="https://wa.me/9647514141213"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
            className="hover:text-green-500 transition"
          >
            <FaWhatsapp />
          </a>
          <a
            href="https://instagram.com/mory.gold"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className="hover:text-pink-500 transition"
          >
            <FaInstagram />
          </a>
        </div>
      </div>
    </div>

    {/* Copyright */}
    <div className="border-t border-gray-700 mt-10 pt-4 text-center text-xs text-gray-500 px-4">
      &copy; {new Date().getFullYear()} MORY. All rights reserved.
    </div>
  </footer>
);

export default Footer;
